import { render, staticRenderFns } from "./PreviousVersionsDialog.vue?vue&type=template&id=4a05f83f&scoped=true&"
import script from "./PreviousVersionsDialog.vue?vue&type=script&lang=js&"
export * from "./PreviousVersionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./PreviousVersionsDialog.vue?vue&type=style&index=0&id=4a05f83f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a05f83f",
  null
  
)

export default component.exports